import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '../containers/Full'

// Views
import Brief from '../components/project/Brief'
import Project from '../components/project/Project'
import ProjectList from '../components/project/List'
import ProjectTalent from '../components/project/Talent'
import Review from '../components/checkout/Review'
import Checkout from '../components/checkout/Checkout'
import Success from '../components/checkout/Success'

import History from '../views/orders/History'
import Order from '../views/orders/Order'

import Profile from '../views/pages/Profile'
import Login from '../views/pages/Login'
import Register from '../views/pages/Register'
import ForgotPassword from '../views/pages/ForgotPassword'
import ResetPassword from '../views/pages/ResetPassword'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: [{
        path: '/',
        redirect: '/projects',
        name: 'HomeFUll',
        component: Full,
        children: [{
            path: 'home',
            name: 'Home',
            component: { render (c) {return c('router-view')} }
        },
        {
            path: 'projects',
            name: 'project',
            redirect: '/projects/new',
            component: {
                render (c) {
                    return c('router-view')
                }
            },
            children: [{
                path: 'new',
                name: 'new',
                component: Project
            },
            {
                path: 'list',
                name: 'projects',
                component: ProjectList
            },
            {
                path: 'brief',
                name: 'brief',
                component: Brief,
                meta: {
                    forVisitors: true,
                    hideFooter: true
                }
            },
            {
                path: ':id',
                name: 'project_id',
                component: Project
            },
            {
                path: ':id/review',
                name: 'review',
                component: Review
            },
            {
                path: ':id/checkout',
                name: 'checkout',
                component: Checkout
            }]
        },
        {
            path: 'orders',
            name: 'orders',
            redirect: '/orders/history',
            component: {
                render (c) {
                    return c('router-view')
                }
            },
            children: [
                {
                    path: 'history',
                    name: 'OrderHistory',
                    component: History
                },
                {
                    path: ':id/submitted',
                    name: 'OrderComplete',
                    component: Success
                },
                {
                    path: ':id',
                    name: 'order',
                    component: Order
                }
            ]
        }]
    },
    {
        path: '/account',
        component: Full,
        children: [
            {path:'', name: 'account', component: Profile}
        ]
    },
    {
        path: '/login',
        component: Full,
        meta: {
            forVisitors: true,
            hideFooter: true
        },
        children: [
            {path:'', name: 'login', component: Login, meta: {
                hideFooter: true
            }}
        ]
    },
    {
        path: '/register',
        component: Full,
        meta: {
            forVisitors: true,
            hideFooter: true
        },
        children: [
            {path:'', name: 'register', component: Register, meta: {
                hideFooter: true
            }}
        ]
    },
    {
        path: '/forgot-password',
        component: Full,
        meta: {
            forVisitors: true,
            hideFooter: true
        },
        children: [
            {path:'', name: 'forgotPassword', component: ForgotPassword, meta: {
                hideFooter: true
            }}
        ]
    },
    {
        path: '/password/reset/:token',
        component: Full,
        meta: {
            forVisitors: true,
            hideFooter: true
        },
        children: [
            {path:'', name: 'resetPassword', component: ResetPassword, meta: {
                hideFooter: true
            }}
        ]
    }]
})



//////////////////
// WEBPACK FOOTER
// ./prompts/router/index.js
// module id = null
// module chunks = 